import React from 'react';
import OutputFormatList from '../../../components/admin/outputFormats/OutputFormatList';

const OutputFormats: React.FC = () => {

    return (<div>
        <OutputFormatList />
    </div>)
};

export default OutputFormats;